const STATUS_META = {
  good: { emoji: '🟢', label: 'Strong' },
  warning: { emoji: '🟡', label: 'Watch' },
  critical: { emoji: '🔴', label: 'At risk' },
}

export function getSellThroughStatusMeta(status) {
  return STATUS_META[status] || STATUS_META.warning
}

export function getPaceStatusMeta(status) {
  return STATUS_META[status] || STATUS_META.warning
}

export function formatPaceDifference(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  const rounded = Math.round(n)
  if (rounded > 0) return `+${rounded}%`
  if (rounded < 0) return `${rounded}%`
  return '0%'
}

export function formatCurrency(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n)
}

export function formatInteger(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return n.toLocaleString('en-US')
}

export function formatSellThrough(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return `${Math.round(n)}%`
}

export function formatComparisonPercent(value, suffix) {
  const n = Number(value)
  if (!Number.isFinite(n)) return `— vs ${suffix}`
  const rounded = Math.round(n)
  if (rounded > 0) return `+${rounded}% vs ${suffix}`
  if (rounded < 0) return `${rounded}% vs ${suffix}`
  return `0% vs ${suffix}`
}

export function comparisonTone(value) {
  const n = Number(value)
  if (!Number.isFinite(n) || n === 0) return 'neutral'
  return n > 0 ? 'positive' : 'negative'
}

export function formatProjectedSellout({ remaining, days }) {
  const remainingQty = Number(remaining)
  const selloutDays = Number(days)

  if (Number.isFinite(remainingQty) && remainingQty <= 0) {
    return 'Sold out'
  }

  if (!Number.isFinite(selloutDays) || selloutDays <= 0) {
    return '—'
  }

  const rounded =
    selloutDays >= 10
      ? Math.round(selloutDays)
      : Math.round(selloutDays * 10) / 10

  return `${rounded} day${rounded === 1 ? '' : 's'}`
}
